import { useEffect, useRef } from 'react'
import consumer from '@/channels/consumer'

interface TaskNotification {
  type: 'task_notification'
  notification_type: string
  title: string
  body: string
  task_id: number
  board_slug: string
  url: string
  created_at: string
}

export function useAgentNotifications() {
  const permissionRef = useRef<NotificationPermission>(
    typeof Notification !== 'undefined' ? Notification.permission : 'denied'
  )

  useEffect(() => {
    if (typeof Notification === 'undefined') return
    if (Notification.permission === 'default') {
      Notification.requestPermission().then((perm) => {
        permissionRef.current = perm
      })
    }
  }, [])

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: 'AgentNotificationsChannel' },
      {
        received(message: TaskNotification) {
          if (message.type === 'task_notification') {
            showNotification(message)
          }
        },
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [])
}

function showNotification(message: TaskNotification) {
  if (typeof Notification === 'undefined') return
  if (Notification.permission !== 'granted') return

  const notification = new Notification(message.title, {
    body: message.body,
    tag: `task-${message.task_id}-${message.notification_type}`,
    data: { url: message.url },
  })

  notification.onclick = () => {
    window.focus()
    window.location.href = message.url
    notification.close()
  }

  setTimeout(() => notification.close(), 10000)
}
